import { createVuetify } from 'vuetify'
import { VFileUpload } from 'vuetify/labs/VFileUpload'
import { VIconBtn } from 'vuetify/labs/VIconBtn'
import { ru } from 'vuetify/locale'

export const vuetify = createVuetify({
  locale: {
    locale: 'ru',
    messages: { ru },
  },
  icons: {
    defaultSet: 'mdi',
  },
  defaults: {
    VTextField: {
      density: 'compact',
      variant: 'solo-filled'
    },
    VTextarea: {
      density: 'compact',
      variant: 'solo-filled'
    },
    VList: {
      density: 'compact',
    },
  },
  theme: {
    themes: {
      light: {
        colors: {
          secondary: '#757575',
          // accent: '#82B1FF',
          error: '#E60023',
          // info: '#2196F3',
          // success: '#4CAF50',
          // warning: '#FFC107'
        }
      },
    }
  },
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
    mobileBreakpoint: 'sm',
  },
  components: {
    VFileUpload,
    VIconBtn
  },
})
